
import { motion } from 'framer-motion';

export function Amenities() {
  const amenityImage = {
    name: '프리미엄 커뮤니티',
    image: 'https://static.readdy.ai/image/9acf540dec95fde23784f4db934ca461/b14155699fcc850d0c1650573945e4b8.png'
  };

  return (
    <section id="amenities" className="py-12 sm:py-16 md:py-24 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8 sm:mb-12 md:mb-16"
        >
          <div className="flex items-center justify-center gap-2 mb-4 sm:mb-6">
            <div className="w-2 h-2 bg-amber-600 rounded-full"></div>
            <p className="text-amber-600 text-xs sm:text-sm font-semibold tracking-wider uppercase">
              PREMIUM COMMUNITY
            </p>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight px-2" style={{ fontFamily: 'Playfair Display, serif' }}>
            품격있는 커뮤니티로 완성되는<br />
            프리미엄 라이프
          </h2>
          <p className="text-gray-600 text-sm sm:text-base md:text-lg max-w-2xl mx-auto px-4">
            입주민의 건강하고 여유로운 일상을 위한 다양한 커뮤니티 시설을 제공합니다
          </p>
        </motion.div>

        {/* Single Image */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative rounded-xl sm:rounded-2xl overflow-hidden shadow-lg"
        >
          <div className="w-full h-[250px] sm:h-[400px] md:h-[550px] lg:h-[750px]">
            <img
              src={amenityImage.image}
              alt={amenityImage.name}
              className="w-full h-full object-cover object-top"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
